(function ($) {
    $(document).ready(function () {
        if ($(".promo-carousel").length > 0) {
            $(window).on("resize", function () {
                winWidth = $(window).width();
            });
            setTimeout(function () {
                $(".promo-carousel .column-wrapper").css({opacity: "1"});
            }, 500);

            $(".promo-carousel .column-wrapper .views-element-container > div").slick(
                {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    cssEase: "linear",
                    adaptiveHeight: false,
                }
            );
            var colTwo = $(".promo-carousel .column-wrapper .card-wrapper").length;
            if (colTwo > 1) {
                $(".promo-carousel .column-wrapper").slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    cssEase: "linear",
                    adaptiveHeight: false,
                });
            }
        }

        $(
            ".promo-carousel.collection .column-wrapper .card-wrapper .card-content h3"
        ).dotdotdot({
            height: 122,
            fallbackToLetter: true,
            watch: true,
        });
    });
})(jQuery);
